export default "__VITE_ASSET__b7b02474__"